import messages from "@intlify/unplugin-vue-i18n/messages";
import { createI18n } from "vue-i18n";

// Messages are loaded from src/locales/<locale>.yaml and packages/shared/src/locales/<locale>.yaml
// (see VueI18nPlugin include in vite.config.ts), deep-merged per locale into one message tree.
// To add a language, add a new yaml file (e.g. es.yaml) with the same keys as en.yaml in both.
export const i18n = createI18n({
	locale: "en",
	fallbackLocale: "en",
	legacy: false,
	messages,
});
